export default __webpack_public_path__ + "static/media/ClairDeLune-ClaudeDebussy.e777a3a3.mp3";